import gql from 'graphql-tag';
import { updateMatchVariables, updateMatch } from 'src/schema';
import { Mutation } from 'react-apollo';

export const UpdateMatchMutationGql = gql`
  mutation updateMatch($data: MatchUpdateInput!, $where: MatchWhereUniqueInput!) {
    updateMatch(data: $data, where: $where) {
      id
    }
  }
`;
export class UpdateMatchMutation extends Mutation<updateMatch, updateMatchVariables> {}



// WEBPACK FOOTER //
// ./src/pages/CustomerPayment/Mutations/UpdateMatchMutation.ts